import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";
import { CPLMaintenanceDatesModel } from "services/api/cplauthapi/CPLAuthAPI";
import { isDateInPast } from "cpl-react-common/Helpers/DateHelpers";

type InitialState = {
  ClientPortalMaintenanceDate: Date | null | undefined;
};

const initialState: InitialState = {
  ClientPortalMaintenanceDate: null,
};

export const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    setCPLMaintenanceDates: (state, action: { payload: CPLMaintenanceDatesModel }) => {
      const { cplClientPortalMaintenanceDate } = action.payload;
      state.ClientPortalMaintenanceDate = cplClientPortalMaintenanceDate ?? null;
    },
  },
});

export const { setCPLMaintenanceDates } = maintenanceSlice.actions;
export const selectClientPortalMaintenanceDate = (state: RootState) => state.maintenance.ClientPortalMaintenanceDate;
export const selectDownForMaintenance = (state: RootState) => {
  const { ClientPortalMaintenanceDate } = state.maintenance;

  return isDateInPast(ClientPortalMaintenanceDate);
};

export default maintenanceSlice.reducer;
